import { Injectable } from '@angular/core';
import { Observable,of, BehaviorSubject } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class AppManagerService {
  unPinIndex = new BehaviorSubject(false);
  unPinIndex$ = this.unPinIndex.asObservable();
  refreshIndex = new BehaviorSubject(false);
  refreshIndex$ = this.refreshIndex.asObservable();
  constructor(private http: HttpClient) { }
  private getHeaders() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return headers;
  }
  catchError(err) {
    console.log('Error:' + err.status);
    console.log(err);
    throw err;
  }
  getApi(url: string):Observable<any> {
    return this.http.get(url, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  postApi(url: string, postValue: any):Observable<any> {
    return this.http.post(url, postValue, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  deleteApi(url: string):Observable<any> {
    return this.http.delete(url, { headers: this.getHeaders() }).pipe(
      map(res => res),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
  getApps(getUrl) {
    return this.getApi(getUrl);
  }
  subscribeAPP(accessURL,appData) {
    return this.postApi(accessURL, appData);
  }
  getFacilitySubscriptionForApps(accessURL) {
    return this.getApi(accessURL);
  }
  subscribeAppDirectly(accessURL,appData) {
    return this.postApi(accessURL, appData);
  }
  deSubscribeApp(accessURL,appData) {
    return this.postApi(accessURL, appData);
  }
}
